<!-- //SEARCH NOT FOUND -->
<div class="container search-not-found">
  <h1>{{ 'SEARCH_NO_RESULT' | translate }}</h1>
  <h2>
    {{ 'SEARCH_FOR' | translate }} <span class="keyword_search">« {{ searchString$ | async }} »</span>
  </h2>
  <img class="img-fluid d-block mx-auto mt-5 mb-2" src="assets/images/feeds/search-no-result.png" />
  <div class="text-center mt-4">
    <a (click)="goToSearchPage()" class="btn btn-etx-darkened btn-xl" role="button"
      ><span>{{ 'SEARCH_NEW' | translate }}</span></a
    >
  </div>
</div>
